import styled from "styled-components";

export const EquipCurrentContent = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 16px;
`;

export const EquipCurrentTitle = styled.div`
  color: ${(props) => props.theme.colors.black80};
  font-size: 1.6rem;
  font-weight: 700;
`;

// export const EquipContentBox = styled.div`
//   display: grid;
//   height: 100%;
//   grid-template-columns: repeat(2, 1fr);
//   grid-template-rows: 332px auto;
//   gap: 16px;
// `;

export const EquipContentBox = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  display: grid;
  height: calc(100svh - 260px);
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 360px calc(100% - 380px);
  gap: 16px;
  scrollbar-gutter: auto;
`;

export const EquipDescriptionText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100svh - 700px);
  font-size: 16px;
  color: ${(props) => props.theme.colors.black60};
`;
